import {
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
} from "@chakra-ui/react";
import React from "react";

const NumberInputLimit = ({ value, onChange }) => {
  return (
    <NumberInput
      defaultValue={value}
      min={5}
      max={700}
      size="sm"
      width="95px"
      h={"28px"}
      value={value}
      onChange={(valueString) => onChange(Number(valueString))}
    >
      <NumberInputField />
      <NumberInputStepper>
        <NumberIncrementStepper />
        <NumberDecrementStepper />
      </NumberInputStepper>
    </NumberInput>
  );
};

export default NumberInputLimit;
